import React, { useEffect, useState } from 'react';
export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);
  function handleAccept() {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  }
  function handleDecline() {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  }
  if (!visible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-brand-navy border-t-[3px] border-brand-red shadow-[0_-4px_20px_rgba(0,0,0,0.15)]" data-id="element-212">
      <div className="max-w-[1100px] mx-auto px-6 py-5 flex flex-col md:flex-row items-start md:items-center gap-4" data-id="element-213">
        <div className="flex-1" data-id="element-214">
          <h4 className="font-serif text-[1rem] font-semibold text-white mb-1" data-id="element-215">
            🍪 Cookie-Hinweis
          </h4>
          <p className="font-sans text-[0.78rem] text-white/70 leading-[1.6] m-0" data-id="element-216">
            Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf
            unserer Website zu bieten. Dazu gehören essenzielle Cookies für den
            Betrieb der Seite sowie optionale Cookies für Analyse und Marketing.
            Weitere Informationen finden Sie in unserer{' '}
            <a href="#" className="text-white underline underline-offset-2 hover:text-brand-red transition-colors" data-id="element-217">
              Datenschutzerklärung
            </a>
            .
          </p>
        </div>
        <div className="flex gap-3 shrink-0" data-id="element-218">
          <button onClick={handleDecline} className="font-sans text-[0.75rem] font-medium tracking-[0.05em] uppercase py-2.5 px-5 border border-white/30 text-white/70 bg-transparent hover:bg-white/10 transition-colors cursor-pointer" data-id="element-219">
            Ablehnen
          </button>
          <button onClick={handleAccept} className="font-sans text-[0.75rem] font-medium tracking-[0.05em] uppercase py-2.5 px-5 bg-brand-red text-white border-none hover:bg-[#A93226] transition-colors cursor-pointer" data-id="element-220">
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>;
}